import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import logoWhite from "../assets/img/logo-white.svg";
import { SITE } from "../config/site";
import { useNavLinks } from "./Navbar";
import { EmailLink } from "./ContactLinks";
import { trackContact } from "../lib/pixel";
import { track } from "../metrics/track";
import { useI18n } from "../i18n";
import LanguageSwitcher from "../i18n/LanguageSwitcher";

const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5h1.5V4.4c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2.4H8v3h2.6V21h2.9z" />
  </svg>
);

export default function Footer({ minimal = false }) {
  const { t } = useI18n();
  const links = useNavLinks();
  const year = new Date().getFullYear();
  const social = (name) => () => track("social", { source: "podnozje", label: name });

  return (
    <footer className="site-footer">
      <div className="container">
        {!minimal && (
          <div className="site-footer-grid">
            <div className="site-footer-brand">
              <img src={logoWhite} alt="Tehnočin DOO Invest" width="150" height="98" loading="lazy" />
              <p>{t("footer.tagline")}</p>
            </div>
            <nav aria-label={t("nav.footer")}>
              <h3>{t("footer.site")}</h3>
              <ul>
                {links.map((link) => (
                  <li key={link.key}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
            <div>
              <h3>{t("footer.contact")}</h3>
              <ul className="site-footer-contact">
                <li>
                  <Phone size={16} aria-hidden="true" />
                  <a href={SITE.phoneHref} onClick={() => trackContact("Poziv", { source: "podnozje" })}>
                    {SITE.phoneDisplay}
                  </a>
                </li>
                <li>
                  <Mail size={16} aria-hidden="true" />
                  <EmailLink source="podnozje" />
                </li>
                <li>
                  <MapPin size={16} aria-hidden="true" />
                  <span>{t("footer.office", { office: SITE.office })}</span>
                </li>
              </ul>
            </div>
            <div>
              <h3>{t("footer.follow")}</h3>
              <div className="site-footer-social">
                <a href={SITE.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" onClick={social("instagram")}>
                  <InstagramIcon />
                </a>
                <a href={SITE.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" onClick={social("facebook")}>
                  <FacebookIcon />
                </a>
              </div>
              <LanguageSwitcher />
            </div>
          </div>
        )}
        <div className="site-footer-bottom">
          <span>
            © {year} {SITE.legalName}. {t("footer.rights")}
          </span>
          {minimal && (
            <span>
              <a href={SITE.phoneHref}>{SITE.phoneDisplay}</a> · <EmailLink source="podnozje" />
            </span>
          )}
        </div>
      </div>
    </footer>
  );
}
